import {
	GET_ALL_SAMPLE_LIST,
    CREATE_SAMPLE_LIST,
    UPDATE_SAMPLE_LIST
} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {normalize, normalizedUpdate, isApiResponseOk} from '../../util/utils';

export default function sampleListReducer(state = initialstate.sampleList, action) {
    switch (action.type) {
        case GET_ALL_SAMPLE_LIST:
            if (isApiResponseOk(action)) {
                let sampleLists = action.response;
                sampleLists = sampleLists?.map((sampleList) => {
                    return {
                        ...sampleList,
                        id: sampleList.sampleListId
                    };
                });
                return normalize(sampleLists, undefined, state);
            } else return state;

        case CREATE_SAMPLE_LIST:
            if (isApiResponseOk(action)) {
                let sampleList = action.response;
                sampleList = {
                    ...sampleList,
                    id: sampleList.sampleListId
                };
                return normalize([sampleList], undefined, state);
            } else return state;

        case UPDATE_SAMPLE_LIST:
			if (isApiResponseOk(action)) {
                state = normalizedUpdate(action.response.sampleListId, action.response, state);
				return state;
			}

			return state;
        default:
            return state;
    }
}